import { defineMessages } from 'react-intl';

export default defineMessages({
  PublicSalesPortal: {
    id: 'PublicSalesPortal',
    defaultMessage: 'Sales Portal',
  },
});
